module.exports = __webpack_public_path__ + "img/user_pad.c119fff4.svg";